module.exports = __webpack_public_path__ + "cb325e9d8940c534c858f9434f70f0bd.svg";